import React from 'react';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';

export default function Help() {
    const navigator = useNavigate();
    return (
        <>
            <Helmet>
                <title>Help | TLK</title>
            </Helmet>
            {/* start: help page */}
            <div className="min-h-screen gradient-bg-1 p-6 pb-32">
                <div className="flex items-center gap-4 mb-8">
                    <button className="text-foreground/70 hover:text-foreground transition-colors"
                        onClick={() => navigator(-1)}
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width={24}
                            height={24}
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth={2}
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            className="lucide lucide-arrow-left w-6 h-6"
                        >
                            <path d="m12 19-7-7 7-7" />
                            <path d="M19 12H5" />
                        </svg>
                    </button>
                    <h1 className="text-xl font-bold text-foreground">Help &amp; Support</h1>
                </div>
                <div className="max-w-md mx-auto" style={{ opacity: 1, transform: "none" }}>
                    <div
                        className="bg-gradient-to-br from-primary/20 via-card to-accent/20 rounded-2xl p-6 border-2 border-primary/30 shadow-lg mb-8"
                        style={{ opacity: 1, transform: "none" }}
                    >
                        <h2 className="font-bold text-foreground mb-2">Need help?</h2>
                        <p className="text-sm text-muted-foreground mb-4">
                            Our support team typically responds within 24 hours.
                        </p>
                        <button className="whitespace-nowrap ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 hover:bg-primary/90 h-10 bg-primary text-primary-foreground hover:opacity-90 rounded-full px-8 py-6 text-lg font-semibold shadow-lg transition-all duration-300 hover:shadow-xl hover:scale-105 w-full flex items-center justify-center gap-2">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="#fff"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="lucide lucide-mail w-4 h-4"
                            >
                                <rect width={20} height={16} x={2} y={4} rx={2} />
                                <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
                            </svg>
                            Contact Support
                        </button>
                    </div>
                    <div className="mb-8">
                        <h2 className="font-semibold text-foreground mb-4">
                            Frequently Asked Questions
                        </h2>
                        <div className="space-y-2">
                            <div
                                className="bg-card rounded-xl border border-border overflow-hidden"
                                style={{ opacity: 1, transform: "none" }}
                            >
                                <button className="w-full flex items-center justify-between p-4 text-left">
                                    <span className="font-medium text-foreground text-sm pr-4">
                                        How do I cancel my subscription?
                                    </span>
                                    <div style={{ transform: "rotate(180deg)" }}>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width={24}
                                            height={24}
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth={2}
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            className="lucide lucide-chevron-down w-5 h-5 text-muted-foreground flex-shrink-0"
                                        >
                                            <path d="m6 9 6 6 6-6" />
                                        </svg>
                                    </div>
                                </button>
                                <div className="overflow-hidden" style={{ height: "auto", opacity: 1 }}>
                                    <div className="px-4 pb-4 text-sm text-muted-foreground border-t border-border pt-3">
                                        You can cancel your subscription anytime from Account Settings → Cancel
                                        Subscription. Your access will continue until the end of your billing
                                        period.
                                    </div>
                                </div>

                            </div>
                            <div
                                className="bg-card rounded-xl border border-border overflow-hidden"
                                style={{ opacity: 1, transform: "none" }}
                            >
                                <button className="w-full flex items-center justify-between p-4 text-left">
                                    <span className="font-medium text-foreground text-sm pr-4">
                                        Can I get a refund?
                                    </span>
                                    <div style={{ transform: "none" }}>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width={24}
                                            height={24}
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth={2}
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            className="lucide lucide-chevron-down w-5 h-5 text-muted-foreground flex-shrink-0"
                                        >
                                            <path d="m6 9 6 6 6-6" />
                                        </svg>
                                    </div>
                                </button>
                                <div className="overflow-hidden" style={{ height: "auto", opacity: 1 }}>
                                    <div className="px-4 pb-4 text-sm text-muted-foreground border-t border-border pt-3">
                                        We offer refunds within 7 days of your first purchase if you're not
                                        satisfied. Contact our support team for assistance.
                                    </div>
                                </div>

                            </div>
                            <div
                                className="bg-card rounded-xl border border-border overflow-hidden"
                                style={{ opacity: 1, transform: "none" }}
                            >
                                <button className="w-full flex items-center justify-between p-4 text-left">
                                    <span className="font-medium text-foreground text-sm pr-4">
                                        How do voice and video minutes work?
                                    </span>
                                    <div style={{ transform: "none" }}>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width={24}
                                            height={24}
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth={2}
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            className="lucide lucide-chevron-down w-5 h-5 text-muted-foreground flex-shrink-0"
                                        >
                                            <path d="m6 9 6 6 6-6" />
                                        </svg>
                                    </div>
                                </button>
                                <div className="overflow-hidden" style={{ height: "auto", opacity: 1 }}>
                                    <div className="px-4 pb-4 text-sm text-muted-foreground border-t border-border pt-3">
                                        Voice and video minutes are included in your plan and reset each billing
                                        cycle. Unused minutes don't roll over to the next month.
                                    </div>
                                </div>

                            </div>
                            <div
                                className="bg-card rounded-xl border border-border overflow-hidden"
                                style={{ opacity: 1, transform: "none" }}
                            >
                                <button className="w-full flex items-center justify-between p-4 text-left">
                                    <span className="font-medium text-foreground text-sm pr-4">
                                        Is my chat history private?
                                    </span>
                                    <div style={{ transform: "none" }}>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width={24}
                                            height={24}
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth={2}
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            className="lucide lucide-chevron-down w-5 h-5 text-muted-foreground flex-shrink-0"
                                        >
                                            <path d="m6 9 6 6 6-6" />
                                        </svg>
                                    </div>
                                </button>
                                <div className="overflow-hidden" style={{ height: "auto", opacity: 1 }}>
                                    <div className="px-4 pb-4 text-sm text-muted-foreground border-t border-border pt-3">
                                        Absolutely. Your conversations are private and encrypted. You can delete
                                        your chat history anytime, and we never share your data with third parties.
                                    </div>
                                </div>

                            </div>
                            <div
                                className="bg-card rounded-xl border border-border overflow-hidden"
                                style={{ opacity: 1, transform: "none" }}
                            >
                                <button className="w-full flex items-center justify-between p-4 text-left">
                                    <span className="font-medium text-foreground text-sm pr-4">
                                        How do I change my plan?
                                    </span>
                                    <div style={{ transform: "none" }}>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width={24}
                                            height={24}
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth={2}
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            className="lucide lucide-chevron-down w-5 h-5 text-muted-foreground flex-shrink-0"
                                        >
                                            <path d="m6 9 6 6 6-6" />
                                        </svg>
                                    </div>
                                </button>
                                <div className="overflow-hidden" style={{ height: "auto", opacity: 1 }}>
                                    <div className="px-4 pb-4 text-sm text-muted-foreground border-t border-border pt-3">
                                        Go to Account Settings → Subscription to view and change your current plan.
                                        Upgrades take effect immediately, while downgrades apply at your next
                                        billing date.
                                    </div>
                                </div>

                            </div>
                            <div
                                className="bg-card rounded-xl border border-border overflow-hidden"
                                style={{ opacity: 1, transform: "none" }}
                            >
                                <button className="w-full flex items-center justify-between p-4 text-left">
                                    <span className="font-medium text-foreground text-sm pr-4">
                                        What payment methods do you accept?
                                    </span>
                                    <div style={{ transform: "none" }}>
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width={24}
                                            height={24}
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth={2}
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            className="lucide lucide-chevron-down w-5 h-5 text-muted-foreground flex-shrink-0"
                                        >
                                            <path d="m6 9 6 6 6-6" />
                                        </svg>
                                    </div>
                                </button>
                                <div className="overflow-hidden" style={{ height: "auto", opacity: 1 }}>
                                    <div className="px-4 pb-4 text-sm text-muted-foreground border-t border-border pt-3">
                                        We accept Google Pay, PayPal, Cash App, and Venmo. All payments are
                                        processed securely.
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div>
                        <h2 className="font-semibold text-foreground mb-4">Quick Links</h2>
                        <div className="grid grid-cols-2 gap-3">
                            <button className="bg-card rounded-xl p-4 border border-border flex items-center gap-2 hover:border-primary/30 transition-colors"
                                onClick={() => navigator('/user/terms')}
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="lucide lucide-external-link w-4 h-4 text-muted-foreground"
                                >
                                    <path d="M15 3h6v6" />
                                    <path d="M10 14 21 3" />
                                    <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
                                </svg>
                                <span className="text-sm text-foreground">Terms of Service</span>
                            </button>
                            <button className="bg-card rounded-xl p-4 border border-border flex items-center gap-2 hover:border-primary/30 transition-colors"
                                onClick={() => navigator('/user/privacy')}
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={24}
                                    height={24}
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth={2}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="lucide lucide-external-link w-4 h-4 text-muted-foreground"
                                >
                                    <path d="M15 3h6v6" />
                                    <path d="M10 14 21 3" />
                                    <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
                                </svg>
                                <span className="text-sm text-foreground">Privacy Policy</span>
                            </button>
                        </div>
                    </div>
                    {/* <div className="mt-8 text-center" style={{ opacity: 1 }}>
                        <p className="text-sm text-muted-foreground mb-3">
                            Or just want to chat?
                        </p>
                        <button className="inline-flex items-center gap-2 text-primary font-medium">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width={24}
                                height={24}
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth={2}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="lucide lucide-message-circle w-4 h-4"
                            >
                                <path d="M7.9 20A9 9 0 1 0 4 16.1L2 22Z" />
                            </svg>
                            Talk to Reya
                        </button>
                    </div> */}
                </div>
            </div>

            {/* end: help page */}

        </>
    );
}

